import { createFileRoute } from '@tanstack/react-router';
import { ReportsManager } from '../../components/admin/ReportsManager';

export const Route = createFileRoute('/admin/reports')({
  component: ReportsTab,
});

function ReportsTab() {
  return <ReportsManager />;
}
